import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import GlobalLoader from "../../common/GlobalLoader";
import EmptyPage from "../../common/emptyPage";
import Cookies from "js-cookie";
import InstitutionCourseCard from "../../admin/institutionCourseCard";
import "../../../styles/institution/institutionBatchCourseList.scss";
import { getAllTeacherCourses } from "../../../helper/apicalls/homework";

const HomeworkCourses = () => {
  const authToken = Cookies.get("institution_token");
  const { setHeaderName, setIsShowSearch } = useOutletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  // No institution-scoped API here; use teacher courses endpoint

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const params = {};
      if (debouncedSearch.trim()) params.search = debouncedSearch.trim();
      const res = await getAllTeacherCourses(params);
      const list = Array.isArray(res?.[0]?.course) ? res[0].course : [];
      setCourses(list);
    } catch (e) {
      console.error("Failed to fetch courses for homework:", e);
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCourseClick = (course) => {
    if (!course?.key) return;
    navigate(`/teacher/homework/batches?course=${course.key}`);
  };

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchInput), 300);
    return () => clearTimeout(t);
  }, [searchInput]);

  useEffect(() => {
    fetchCourses();
  }, [debouncedSearch]);

  useEffect(() => {
    setHeaderName && setHeaderName("Homework");
    setIsShowSearch && setIsShowSearch(true);
  }, [setHeaderName, setIsShowSearch, location.pathname]);

  return (
    <div className="institution-batch-course-container">
      <GlobalLoader visible={loading} text="Loading courses..." />
      <div className="institution-batch-course-header">
        <h4 className="section-title">Courses List</h4>
      </div>
      {Array.isArray(courses) && courses.length > 0 ? (
        <div className="institution-batch-course-grid">
          {courses.map((course) => (
            <InstitutionCourseCard
              key={course.id || course.key}
              course={course}
              onClick={handleCourseClick}
              hideMenuIcon={true}
            />
          ))}
        </div>
      ) : (
        <EmptyPage content={"No courses Available"} />
      )}
    </div>
  );
};

export default HomeworkCourses;
